import colors from 'config/colors.module.scss';
import { DonationOutput } from 'gql/types';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.WeightChart');

export const getConfig = (donationData: DonationOutput[]) => {
  return {
    data: donationData,
    xField: 'donationDate',
    yField: 'weight',
    color: colors.pastelYellow,
    xAxis: {
      title: {
        text: t('date'),
      },
    },
    yAxis: {
      title: {
        text: t('weight'),
      },
      alias: t('weight'),
    },
  };
};
